"use client";
import { createContext } from "react";
/**
 * @public
 */
export const PresenceContext = 
/* @__PURE__ */ createContext(null);
//# sourceMappingURL=PresenceContext.js.map